import type { SVGProps } from 'react';
const SvgXCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <desc>{'Delete 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M.748 12a11.25 11.25 0 1 0 22.5 0 11.25 11.25 0 1 0-22.5 0M7.498 16.5l8.999-9M16.498 16.5l-9.001-9"
    />
  </svg>
);
export default SvgXCircle;
